import tablePaginationStyles from 'styles/tablePagination.style';

export default {
  container: {
    display: 'contents',
  },
  grid: {
    '&.MuiDataGrid-root': {
      paddingBottom: 0,
    },
    '.MuiCheckbox-root.Mui-checked': {
      color: (theme) => theme.palette.blues.primaryBlue500,
    },
    '.MuiCheckbox-indeterminate': {
      color: (theme) => theme.palette.blues.primaryBlue500,
    },
    '.MuiDataGrid-row.Mui-selected': {
      backgroundColor: (theme) => theme.palette.blues.primaryBlue100,
    },
    '.MuiDataGrid-row.Mui-selected.Mui-hovered': {
      backgroundColor: (theme) => theme.palette.blues.primaryBlue100,
    },
    '.MuiDataGrid-columnSeparator': {
      color: (theme) => theme.palette.grays.gray300,
      height: '100%',
    },
    '.MuiDataGrid-footerContainer': {
      paddingY: '16px',
      paddingRight: '16px',
      minHeight: 'unset',
    },
    '.MuiDataGrid-columnHeaders': {
      color: (theme) => theme.palette.grays.gray900,
    },
    '.MuiDataGrid-columnHeader.MuiDataGrid-columnHeaderCheckbox': {
      outline: 'none !important',

      color: (theme) => theme.palette.grays.gray900,
      padding: 0,
      borderRight: (theme) => `1px solid ${theme.palette.grays.gray300}`,
      '&:last-of-type': {
        borderRight: 'none',
      },
      '&:hover': {
        backgroundColor: (theme) => theme.palette.grays.lightestGray,
        color: (theme) => theme.palette.grays.gray900,
      },
    },
    '.MuiDataGrid-columnHeader': {
      outline: 'none !important',
      color: (theme) => theme.palette.grays.gray900,
      '&:hover': {
        backgroundColor: (theme) => theme.palette.grays.lightestGray,
        color: (theme) => theme.palette.grays.gray900,
      },
    },
    '.MuiDataGrid-columnHeaderTitle': {
      fontWeight: '700',
    },
    '.MuiDataGrid-row': {
      '&:hover': {
        backgroundColor: (theme) => theme.palette.grays.lightestGray,
        color: (theme) => theme.palette.grays.gray900,
      },
    },
    '& .MuiDataGrid-cell.MuiDataGrid-cellCheckbox': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      padding: '0px 0px 0px 0px',
      borderRight: (theme) => `1px solid ${theme.palette.grays.gray300}`,
      '& a': {
        color: (theme) => theme.palette.blues.primaryBlue,
        '&:hover': {
          color: (theme) => theme.palette.blues.primaryBlue,
        },
      },
      '&:focus-within': {
        outline: 'none',
        boxShadow: (theme) =>
          `inset 0 0 0 2px ${theme.palette.blues.primaryBlue}`,
      },
      '&:last-of-type': {
        borderRight: 'none',
      },
      '&:focus': {
        outline: 'none',
        boxShadow: (theme) =>
          `inset 0 0 0 2px ${theme.palette.blues.primaryBlue}`,
      },
      '&:hover': {
        backgroundColor: (theme) => theme.palette.blues.lightestBlue,
      },
    },
    '& .MuiDataGrid-cell': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '& a': {
        color: (theme) => theme.palette.blues.primaryBlue,
        '&:hover': {
          color: (theme) => theme.palette.blues.primaryBlue,
        },
      },
      '&:focus-within': {
        outline: 'none',
        boxShadow: (theme) =>
          `inset 0 0 0 2px ${theme.palette.blues.primaryBlue}`,
      },
      '&:focus': {
        outline: 'none',
        boxShadow: (theme) =>
          `inset 0 0 0 2px ${theme.palette.blues.primaryBlue}`,
      },
      '&:hover': {
        backgroundColor: (theme) => theme.palette.blues.lightestBlue,
      },
    },
    '.MuiDataGrid-selectedRowCount': {
      minWidth: '200px',
      margin: 0,
      fontWeight: 400,
      fontSize: '14px',
      paddingLeft: '6px',
      lineHeight: 1.5,
      color: (theme) => theme.palette.blues.primaryBlue,
    },
  },
  pagination: tablePaginationStyles,
  isNewGrid: {
    '&.MuiDataGrid-root': {
      borderRadius: 2,
      border: (theme) => `1px solid ${theme.palette.grays.gray150}`,
    },
  },
};
